import { useState } from 'react'
import { deleteDomain } from '@/api/domains'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { toast } from 'sonner'

interface DeleteDomainDialogProps {
  domain: string | null
  accountId: string | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onSuccess: () => void
}

export function DeleteDomainDialog({
  domain,
  accountId,
  open,
  onOpenChange,
  onSuccess,
}: DeleteDomainDialogProps) {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    if (!domain || !accountId) return

    setIsDeleting(true)
    const result = await deleteDomain(accountId, domain)
    setIsDeleting(false)

    if (result.success) {
      toast.success(`Domain ${domain} deleted successfully`)
      onSuccess()
    } else {
      toast.error(result.error || 'Failed to delete domain')
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Domain</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete <strong>{domain}</strong>? This action cannot be undone.
            All associated SES resources will be removed.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete Domain'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
